// Display calculator will calculate the weapon damage showed on a weapon,
// and also the defense showed on armors.
module.exports = {
    calculate: function(attributes) {
        return this.calculateAttributes(attributes, {
            enhancedDurability: 0,
            enhancedDefense: 0,
            minEnhancedDamage: 0,
            maxEnhancedDamage: 0,
            flatDurability: 0,
            flatOneHandMin: 0,
            flatOneHandMax: 0,
            flatTwoHandMin: 0,
            flatTwoHandMax: 0,
            flatThrowMin: 0,
            flatThrowMax: 0,
            flatDefense: 0
        });
    },
    calculateAttributes: function(attributes, values) {
        // If the list is empty, we'll just return it.
        if (attributes.length === 0) {
            return values;
        }

        attributes.map(function(attr) {
            switch(attr.id) {
                // Enhanced defense.
                case 16:
                    values.enhancedDefense += attr.value;
                    break;

                // Flat durability
                case 73:
                    values.flatDurability += attr.value;
                    break;

                // Durability enhancer
                case 75:
                    values.enhancedDurability += attr.value;
                    break;

                // Flat defense and Flat defense per level.
                case 31:
                case 214:
                    values.flatDefense += attr.value;
                    break;

                // Default, just continue.
                default:
                    break;
            }
            return true;
        });

        return values;
    }
}



// WEBPACK FOOTER //
// ./src/components/character/item/display-calculator.js